import axiosClient from "./axiosClient";

/**
 * Google One Tap Sign-In API
 * @param idToken - The JWT credential from Google One Tap
 * @returns Response with access token
 */
export interface GoogleOneTapResponse {
  accessToken: string; // 
  tokenType: string; // "Bearer"
}

export const googleOneTapSignIn = async (idToken: string): Promise<GoogleOneTapResponse> => {
  try {
    const response = await axiosClient.post("/auth/google-one-tap", {
      idToken: idToken
    });
    // console.log('[One Tap API] Success - received access token');
    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};
